import { useSrpContext } from '@/src/contexts'
import { getFlightLogo } from '@/src/utils/confirmation/airlineUtils'
import { useMemo } from 'react'

import AirlineComparison from './airlineComparison'

const AirlineComparisonWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()

    const airlineComparison = sections?.airlines?.comparison
    if (!airlineComparison?.length) return null

    const airlines = useMemo(
        () =>
            airlineComparison.map(airline => ({
                ...airline,
                logoUrl: getFlightLogo(airline.airlineCode)
            })),
        [airlineComparison]
    )

    return <AirlineComparison airlines={airlines} />
}

export default AirlineComparisonWrapper
